import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import {
  CalendarForm,
  type IRange,
  KyrgyzstanLoader,
  kyrgyzstanDetailContextStore,
  kyrgyzstanDetailSelectionStore,
  useAvailableDates,
} from 'entities/kyrgyzstan'
import { DefaultGuests } from 'entities/kyrgyzstan/model/search/search-store'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanCalendarBookingPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { effectiveRealty, restoreSelection } = kyrgyzstanDetailSelectionStore
  const { detailSearchParams, restoreSavedContext, setBookingDates } =
    kyrgyzstanDetailContextStore

  useEffect(() => {
    restoreSavedContext()
    restoreSelection()
  }, [restoreSavedContext, restoreSelection])

  const objectId = effectiveRealty?.id

  const { availableDates, isLoading: isLoadingAvailableDates } =
    useAvailableDates({
      objectId,
      visitorsCount: detailSearchParams?.visitors_count ?? DefaultGuests.adults,
      childrenAges: detailSearchParams?.children_ages ?? [],
    })

  const initialDates: IRange = {
    startDate: detailSearchParams?.start_date,
    endDate: detailSearchParams?.end_date,
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmit = (dates: IRange) => {
    setBookingDates(dates)

    navigate(-1)
  }

  return (
    <div className={clsx('container', s.container)}>
      <HeaderGoBack
        title={t('kyrgyzstan_block.calendar.title')}
        onGoBack={handleGoBack}
        buttonWhite
        variant="grey"
      />

      {isLoadingAvailableDates ? (
        <KyrgyzstanLoader />
      ) : (
        <CalendarForm
          initialDates={initialDates}
          availableDates={availableDates}
          onSubmit={handleSubmit}
          showSubmitButton
        />
      )}
    </div>
  )
})

export default KyrgyzstanCalendarBookingPage
